var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAccessTimeOutline = function SvgAccessTimeOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 14c3.83 0 7-3.17 7-7 0-3.823-3.178-7-7.007-7C3.671 0 .5 3.177.5 7c0 3.83 3.177 7 7 7Zm0-1.167A5.805 5.805 0 0 1 1.674 7a5.804 5.804 0 0 1 5.82-5.833A5.825 5.825 0 0 1 13.333 7 5.807 5.807 0 0 1 7.5 12.833Zm.474-5.572c0 .274-.213.48-.48.48H3.91a.47.47 0 0 1-.48-.48c0-.268.205-.474.48-.474H7.02V2.635c0-.267.205-.473.473-.473s.48.206.48.473v4.626Z",
    fill: "currentColor"
  })));
};
export default SvgAccessTimeOutline;